import { FC } from "react";
import cx from "classnames";

import { getTooltipDimensions } from "./../../../helpers/tooltipActions";
import { IContentProps as IProps, TooltipBeginning } from "./../types";

import { ReactComponent as ArrowIcon } from "./../../../assets/images/tooltipArrow.svg";

import styles from "./styles.module.scss";

// This is to get CSS positions using TooltipPosition.
const possitions = [styles.left, styles.topLeft, styles.topRight, styles.right, styles.bottomRight, styles.bottomLeft];
const startPossitions = [
    styles.startLeft,
    styles.startTopLeft,
    styles.startTopRight,
    styles.startRight,
    styles.startBottomRight,
    styles.startBottomLeft,
];
const endPossitions = [
    styles.endLeft,
    styles.endTopLeft,
    styles.endTopRight,
    styles.endRight,
    styles.endBottomRight,
    styles.endBottomLeft,
];

const Content: FC<IProps> = ({
    changeTooltipRef,
    position,
    beginning,
    tooltipDimensions,
    className,
    content,
    isValidationMode,
}) => {
    return (
        <div
            className={cx(styles.tooltip, {
                [styles.isValidationMode]: isValidationMode,
                [className!]: className,
                [possitions[position]]: beginning === TooltipBeginning.CENTER,
                [startPossitions[position]]: beginning === TooltipBeginning.LEFT,
                [endPossitions[position]]: beginning === TooltipBeginning.RIGHT,
            })}
            ref={getTooltipDimensions({
                changeTooltipRef,
                tooltipDimensions,
            })}
        >
            <ArrowIcon className={styles.arrow} />

            {content}
        </div>
    );
};

export default Content;
